<template>
  <div class="underLogoPhrase">
    <h2 class="font-weight-bold mb-4 centers">Les Animaux</h2>
  </div>

  <!-- Liste animaux -->
  <div class="container-fluid">
    <div class="row">
      <div
        class="col-lg-3"
        v-for="animau in animauxFiltres"
        :key="animau.id"
      >
        <router-link
          :to="'/animaux/' + animau.id"
          class="card"
          style="height:auto; min-height:350px;"
        >
          <div>
            <img
              :src="'https://admin.asso-refuge.fr/images/' + animau.img1"
              :alt="'photo du chien chat à l adoption au refuge SOS Animaux Le Broc dans le Puy-de-Dôme' + animau.type + ' ' + animau.name"
              class="tailleimg"
              :title="animau.name + ' ' + animau.race"
            />
          </div>

          <div class="endessous" style="margin-top:10px;margin-bottom:30px;">
            <h4 class="namedogtitleback">{{ animau.name }}</h4>
            <h6>{{ animau.race }}</h6>
            <h6>
              <strong>Age : {{ calculateAge(animau.naissance) }}</strong>
            </h6>
            <h6 style="color:red">{{ animau.huge_information }}</h6>
            <i class="fas fa-plus-circle"></i>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import convertAge from '../components/getAge.js';

export default {
  data() {
    return {
      animaux: [],
      lastUpdateChien: null,
      lastUpdateChat: null,
      filtres: {
        type: '',
        sexe: '',
        couleur: '',
        age: '',
        ville: ''
      }
    };
  },

  computed: {
    animauxFiltres() {
      const { type, sexe, couleur, age, ville } = this.filtres;

      return this.animaux.filter(animal => {
        if (type && animal.type !== type) return false;
        if (sexe && animal.sexe !== sexe) return false;
        if (couleur && animal.couleur !== couleur) return false;
        if (ville && animal.ville !== ville) return false;

        if (age) {
          const mois = this.ageEnMois(animal.naissance);
          if (age === 'bebe' && mois >= 6) return false;
          if (age === 'ado' && (mois < 6 || mois > 24)) return false;
          if (age === 'adulte' && mois <= 24) return false;
        }

        return true;
      });
    },

    couleursDisponibles() {
      return [...new Set(this.animaux.map(a => a.couleur).filter(Boolean))];
    },

    villesDisponibles() {
      return [...new Set(this.animaux.map(a => a.ville).filter(Boolean))];
    }
  },

  watch: {
    '$route.query.type': {
      immediate: true,
      handler(type) {
        this.filtres.type = type || '';
      }
    }
  },

  mounted() {
    const idSite = this.$idSite;

    fetch(`https://admin.asso-refuge.fr/getAnimal/${idSite}`)
      .then(res => res.json())
      .then(data => {
        this.animaux = data;
        this.calculerDernieresMAJ();
      })
      .catch(err => {
        console.error('Erreur chargement animaux :', err);
      });
  },

  methods: {
    resetFiltres() {
      this.filtres = {
        type: this.$route.query.type || '',
        sexe: '',
        couleur: '',
        age: '',
        ville: ''
      };
    },

    calculateAge(dateOfBirth) {
      return convertAge(dateOfBirth);
    },

    ageEnMois(dateOfBirth) {
      if (!dateOfBirth) return 0;
      const birth = new Date(dateOfBirth);
      const now = new Date();
      return (
        (now.getFullYear() - birth.getFullYear()) * 12 +
        (now.getMonth() - birth.getMonth())
      );
    },

    calculerDernieresMAJ() {
      const maxDate = arr =>
        arr.reduce((a, b) =>
          new Date(a.created_at) > new Date(b.created_at) ? a : b
        );

      const chiens = this.animaux.filter(a => a.type === 'chien');
      const chats = this.animaux.filter(a => a.type === 'chat');

      this.lastUpdateChien = chiens.length ? maxDate(chiens).created_at : null;
      this.lastUpdateChat = chats.length ? maxDate(chats).created_at : null;
    }
  }
};
</script>
